import { render, staticRenderFns } from "./WalletTrans.vue?vue&type=template&id=1625c3ac"
import script from "./WalletTrans.vue?vue&type=script&lang=js"
export * from "./WalletTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports